import React from 'react'
import { Imprimir } from '@newspacebpo/mf_protocolo_bfveic'
const ImprimirPage = (props) => {
    return (
            <Imprimir {...props}/>
    );
};

export { ImprimirPage };